import admin from "firebase-admin";
import { randomUUID } from "node:crypto";
const type = "service_account";
const project_id = "blinder-73755";
const private_key_id = "8466c9ee0463ac7ddf811b6c8d9c40cc7e5a505f";
const private_key = "-----BEGIN PRIVATE KEY-----\nMIIEvgIBADANBgkqhkiG9w0BAQEFAASCBKgwggSkAgEAAoIBAQDA6drxIRd+mfbZ\n7MYip7Tffh1kR433vNcVzfXg8nazUWspQlcRKLBD06/mAmoauTD1H/aC7rxecEZn\n9kIfuvVr0YfcUssy8frkZAgNq4FMwqk6c1650bPc9tj/VS4pIt/7xsUzedr1ER84\n8qJuft8LSVepYQ4fKagMZ5aufoo/k5zUiaFzMRrqseNTZQ2TGdsR7yCJIMYBb9+U\ntHvrGYyzHGbzhl4q/jEm/tqbcL1/ZYprjMgy3j8oQZZ/7ZldCvsMA5Lqs9duJOc5\nyf/ZcJCmW/T0hm4aRksG8U6z0VvFcrV2O7tOmP0IdfbSkq1x5kuLY4EITk++ngeM\nvIkqXpvvAgMBAAECggEAW1beeUkHzMOtY2V+Mq5hL2iRFgfjKidZV1ObVZS3qxOj\nv3dPrioruxGhuS/veROyIH2vxDKxMa3LSDILAOcOiKw+vYzd9RMpjbXnMkHACM4q\nPiid8zFdDgQ6njqAjq2ai6WDfWn2yA4BUH9hdRvRE5D4VpRDkXGxxZ3OdHQplQvG\nSc7MiPWwH/MsjzVbpvA/ZDTR+7LR43/+JigIAjr0cvrgTE2XhgDMktQel6eb/2Ob\n0JjuhWQp71djWLs4JGdy0lGP7p5wipGVDFFZhzxz18rSfiB8USy9Ko3wAevCs72q\nv0Q3dFQoAGKluFA4rNWitLYFqwhdXxqwZN5rUMj78QKBgQDt37WsxWlCb8AZ4yOH\ngCt1pQXhvX7LaMFvVmpKKurQDJqrNS9moY51IpzVQXUUBaORPFLV5BCpBiDtYqhS\nxvchQcmKhqO0rl1W4QkwN3TE2hKrstJFGdB6OKi9gIwdlzMCcQi4tBRZGvmamYpt\nco9amIgLCKTzvRIlx5WlwQd4swKBgQDPnRZunfSE5LdfQb4gN0xlF3i2bw9pT1KZ\n+JM9O5AVDw6vB1ZbnRocP8cbDRL6x7lmXUWrPSzdK6uWFrLpftUKgBaa2EVF74et\nqxXvyWcSPDONl62Sq/ALyH/SU9w215p6qiB9tPAnFT7t5RA6WHzHpVmZ/kqx0+gO\nUv9A3/2V1QKBgGijWQqoSHZWLD33AeEQS43TyvOTZRxbd4PfkqAPov1kHgGkQra1\n6LG0SSMySStGk75Gt/Wo/n8r1/40wPCw33M8ukh6k7beYObf1SflrTMO7tmirwaA\npYmuNOQvkPNPWLwBNyHw7WaJDDWqxw8ALvleUbHw2obxq/L8ieLBN+UrAoGBALQM\nw9uC2QA3amAOH9jInFQ/msx8XJ0z0ar+TJMaCMZ6nH1mm5owEOjW1tG68O7ULxF7\namQrVbEpolEztk2RVSkaFICNduZD6SLP8OJXhC/oTb1KAZnlyvQtGc1KNPzK1ony\n6OKb/Hmojz65HO28t9pcp+xJAHZgFCv4Bq44ky9RAoGBAOGm7yf6eF2kUvau6wRZ\nC43FInKew9M4+JAoiLjzaph6c8bAlYF4ePWZqQ2Z/nsMotgBYe16eBM5jcAKMep7\nMIsRldswizjFAZ1d6xF2KjpWeQiFfEMPwg7q01SONtiTcDMtHhLtIkLiQ4fdDEyq\ndhs5woPSHMWK4Q2Scr/WtKrc\n-----END PRIVATE KEY-----\n";
const client_email = "firebase-adminsdk-c1v0e@blinder-73755.iam.gserviceaccount.com";
const client_id = "111282897622837304961";
const auth_uri = "https://accounts.google.com/o/oauth2/auth";
const token_uri = "https://oauth2.googleapis.com/token";
const auth_provider_x509_cert_url = "https://www.googleapis.com/oauth2/v1/certs";
const client_x509_cert_url = "https://www.googleapis.com/robot/v1/metadata/x509/firebase-adminsdk-c1v0e%40blinder-73755.iam.gserviceaccount.com";
const universe_domain = "googleapis.com";
const serviceAccount = {
  type,
  project_id,
  private_key_id,
  private_key,
  client_email,
  client_id,
  auth_uri,
  token_uri,
  auth_provider_x509_cert_url,
  client_x509_cert_url,
  universe_domain
};
const initializeApp = (name) => admin.initializeApp(
  {
    credential: admin.credential.cert(serviceAccount)
  },
  name
);
const app = () => initializeApp(randomUUID());
const db = () => admin.firestore(app());
const UserCollection = () => db().collection("users");
const LicenseCollection = () => db().collection("licenses");
const InstallerCollection = () => db().collection("installers");
const SessionCollection = () => db().collection("sessions");
const getUsersByEmail = (email) => {
  return UserCollection().where("email", "==", email).get();
};
export {
  InstallerCollection as I,
  LicenseCollection as L,
  SessionCollection as S,
  UserCollection as U,
  getUsersByEmail as g,
  initializeApp as i
};
